import React, { useEffect, useState } from 'react';
import BodyContainer from '../BodyContainer';
import EventCard from '../EventCard';
// import EventCard from "../eventCard/EventCard";
import Loader from '../Loader';
import Services from '../../services/services';
import EmptyMessage from './EmptyMessage';
// import AOS from 'aos';
// import 'aos/dist/aos.css';

function UpComingEvents({ image, userId }) {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    getListOfEvents();
  }, []);

  // useEffect(() => {
  //   AOS.init({ duration: 2000 });
  //   AOS.refresh();
  // }, []);

  const getListOfEvents = () => {
    Services.list_events()
      .then((res) => {
        setLoader(false);
        setData(res.data.listOfHostEvents);
        return null;
      })
      .catch((err) => {
        setLoader(false);
        return null;
      });
  };

  return (
    <BodyContainer title="Public Events">
      {data?.length ? (
        data.map((each) => {
          const isEventCancelled = each?.eventStatus === 'cancelled';

          return (
            isEventCancelled || (
              <EventCard
                // data-aos={'fade-up'}
                // data-aos-offset='2000'
                // data-aos-easing='ease-in-sine'
                // data-aos-duration='6000'
                data={each}
                key={each.eventId}
                image={image}
                dataFrom="UpcomingEvents"
                userId={userId}
              />
            )
          );
        })
      ) : (
        <EmptyMessage />
      )}
      <Loader open={loader} />
    </BodyContainer>
  );
}

export default UpComingEvents;
